/**
 * Before After FAQ Component
 */
export class BeforeAfterFaq {
    constructor() {
        // 기존 initBeforeAfterFaq 로직 유지
        if (typeof initBeforeAfterFaq === 'function') {
            initBeforeAfterFaq();
        }
    }
}

